module.exports = __webpack_public_path__ + "media/images/citiesBannerGraphic-774c9107.svg";